import { useEffect, useState } from 'react';
import api from '../api';
import './home.css';

export default function AdminSfgTestImport() {
  const [url, setUrl] = useState('');
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [ok, setOk] = useState('');
  const [preview, setPreview] = useState(null); // { lines:[], bytesRead, contentType, sourceUrl, rowsEF }
  const [importResult, setImportResult] = useState(null); // detailed result of simulation/import
  const [cleanup, setCleanup] = useState(null); // cleanup result

  useEffect(() => {
    let alive = true;
    api.get('/admin/sfg-import').then(res => {
      if (!alive) return;
      const v = res.data?.sfgSupportplanCsvUrl || '';
      const en = !!res.data?.sfgImportEnabled;
      setUrl(v);
      setEnabled(en);
      setLoading(false);
    }).catch(e => {
      if (!alive) return;
      setError(e?.response?.data?.error || e.message);
      setLoading(false);
    });
    return () => { alive = false; };
  }, []);

  async function save() {
    setSaving(true); setError(''); setOk('');
    try {
      const body = { sfgSupportplanCsvUrl: (url || '').trim(), sfgImportEnabled: !!enabled };
      const { data } = await api.put('/admin/sfg-import', body);
      setUrl(data?.sfgSupportplanCsvUrl || '');
      setEnabled(!!data?.sfgImportEnabled);
      setOk('Gespeichert');
    } catch (e) {
      setError(e?.response?.data?.error || e.message);
    } finally { setSaving(false); }
  }

  async function testLoad() {
  setError(''); setOk(''); setPreview(null); setImportResult(null); setCleanup(null);
    const u = (url || '').trim();
    try {
      const qp = u ? `?url=${encodeURIComponent(u)}` : '';
      const { data } = await api.get(`/admin/sfg-import/test${qp}`);
      setPreview(data || null);
      if (!u && data?.sourceUrl) setOk('Vorschau geladen (gespeicherte URL)');
      else setOk('Vorschau geladen');
    } catch (e) {
      setError(e?.response?.data?.error || e.message);
    }
  }

  if (loading) return <div style={{padding:24}}>Lade ...</div>;

  return (
    <div className="home-page">
      <section style={{ width:'100vw', margin:0, padding:0, position:'relative', left:'-120px' }}>
        <h2 className="hero-title" style={{ textAlign:'center', margin:'0 0 8px' }}>SFG-TEST-Import</h2>
        <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign:'center', maxWidth:760 }}>Hinterlege hier die URL zur SFG Supportplan CSV-Datei.</p>
      </section>
      <section style={{ width:'100%', maxWidth: 800, margin:'0 auto', padding:'0 16px 40px 16px', color:'#fff' }}>
        {error && <div style={{color:'tomato',marginBottom:12}}>{error}</div>}
        {ok && <div style={{color:'#32CD89',marginBottom:12}}>{ok}</div>}
        <div style={{ border:'1px solid rgba(255,255,255,0.15)', borderRadius:8, padding:16, marginBottom:16, background:'rgba(255,255,255,0.03)' }}>
          <h3 style={{ marginTop:0, marginBottom:8 }}>CSV-Quelle</h3>
          <div style={{display:'grid', gap:8}}>
            <label style={{display:'flex', alignItems:'center', gap:8}}>
              <input type="checkbox" checked={enabled} onChange={e=>setEnabled(e.target.checked)} />
              Automatische Verarbeitung aktivieren
            </label>
            <div>
              <div style={{ marginBottom:6 }}>SFG Supportplan CSV URL</div>
              <input type="url" value={url} onChange={e=>setUrl(e.target.value)} placeholder="https://example.com/supportplan.csv" className="hero-btn-secondary" />
              <div style={{ fontSize:12, opacity:.75, marginTop:4 }}>Erwartet eine öffentlich erreichbare CSV-Datei. HTTPS empfohlen.</div>
            </div>
            <div>
              <button className="hero-btn-primary" onClick={save} disabled={saving}>{saving? 'Speichere…' : 'Speichern'}</button>
              <button className="hero-btn-secondary" style={{marginLeft:8}} onClick={testLoad}>Test laden</button>
              {enabled && (
                <>
                  <button className="hero-btn-secondary" style={{marginLeft:8}} onClick={async()=>{
                    setError(''); setOk(''); setImportResult(null);
                    try {
                      const { data } = await api.post('/admin/sfg-import/run', { simulation: true });
                      setImportResult(data);
                      setOk(`Simulation: würde erstellen ${data.wouldCreateCount}, Duplikate ${data.duplicatesCount}, übersprungen ${data.skippedCount}`);
                    } catch (e) {
                      setError(e?.response?.data?.error || e.message);
                    }
                  }}>Simulation</button>
                  <button className="hero-btn-secondary" style={{marginLeft:8}} onClick={async()=>{
                    setError(''); setOk(''); setImportResult(null);
                    try {
                      const { data } = await api.post('/admin/sfg-import/run', { simulation: false });
                      setImportResult(data);
                      setOk(`Import abgeschlossen: erstellt ${data.createdCount}, Duplikate ${data.duplicatesCount}, übersprungen ${data.skippedCount}`);
                    } catch (e) {
                      setError(e?.response?.data?.error || e.message);
                    }
                  }}>Import starten</button>
                  <button className="hero-btn-secondary" style={{marginLeft:8, background:'#7f1d1d', borderColor:'#7f1d1d'}} onClick={async()=>{
                    setError(''); setOk(''); setCleanup(null);
                    const confirm = window.confirm('Sollen alle Test-Import-Einträge (exakt passender Titel & Beschreibung) wirklich gelöscht werden?');
                    if (!confirm) return;
                    try {
                      const body = { title: 'SFG-TEST-IMPORT', description: 'Das ist ein Test-Import eintrag aus dem SFG-Supportplan!!!', platform: 'Twitch' };
                      const { data } = await api.delete('/admin/sfg-import/cleanup', { data: body });
                      setCleanup(data);
                      setOk(`Löschung abgeschlossen: ${data.deleted || 0} Einträge gelöscht`);
                    } catch (e) {
                      setError(e?.response?.data?.error || e.message);
                    }
                  }}>Test-Import-Einträge löschen</button>
                </>
              )}
            </div>
            {cleanup && (
              <div style={{ marginTop:12, border:'1px solid rgba(255,255,255,0.15)', borderRadius:8, padding:12 }}>
                <div style={{ fontWeight:600, marginBottom:8 }}>Lösch-Ergebnis</div>
                <div style={{ marginBottom:8 }}>Gelöscht: {cleanup.deleted || 0}</div>
                {Array.isArray(cleanup.ids) && cleanup.ids.length > 0 && (
                  <details>
                    <summary>Gelöschte IDs anzeigen ({cleanup.ids.length})</summary>
                    <pre style={{ whiteSpace:'pre-wrap', wordBreak:'break-word', background:'#0b1220', padding:12, borderRadius:6, marginTop:8 }}>{cleanup.ids.join(', ')}</pre>
                  </details>
                )}
              </div>
            )}
            {importResult && (
              <div style={{ marginTop:12, border:'1px solid rgba(255,255,255,0.15)', borderRadius:8, padding:12 }}>
                <div style={{ fontWeight:600, marginBottom:8 }}>
                  Ergebnis ({importResult.mode === 'simulation' ? 'Simulation' : 'Live'}):
                  {' '}Erstellt: {importResult.createdCount || 0} · Würde erstellen: {importResult.wouldCreateCount || 0} · Duplikate: {importResult.duplicatesCount || 0} · Übersprungen: {importResult.skippedCount || 0}
                </div>
                {Array.isArray(importResult.wouldCreate) && importResult.wouldCreate.length > 0 && (
                  <div style={{ marginBottom:16 }}>
                    <div style={{ fontWeight:600, marginBottom:6 }}>Würde erstellt werden ({importResult.wouldCreate.length})</div>
                    <div style={{ overflowX:'auto', border:'1px solid rgba(255,255,255,0.15)', borderRadius:6 }}>
                      <table style={{ width:'100%', borderCollapse:'collapse' }}>
                        <thead>
                          <tr>
                            <th style={{ textAlign:'left', padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.15)' }}>Slot</th>
                            <th style={{ textAlign:'left', padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.15)' }}>User</th>
                            <th style={{ textAlign:'left', padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.15)' }}>Start</th>
                            <th style={{ textAlign:'left', padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.15)' }}>Ende</th>
                            <th style={{ textAlign:'left', padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.15)' }}>Link</th>
                          </tr>
                        </thead>
                        <tbody>
                          {importResult.wouldCreate.map((r, idx) => (
                            <tr key={idx}>
                              <td style={{ padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.08)' }}>{r.slot}</td>
                              <td style={{ padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.08)' }}>{r.user}</td>
                              <td style={{ padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.08)' }}>{r.start ? new Date(r.start).toLocaleString() : ''}</td>
                              <td style={{ padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.08)' }}>{r.end ? new Date(r.end).toLocaleString() : ''}</td>
                              <td style={{ padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.08)' }}>
                                {r.streamLink ? <a href={r.streamLink} target="_blank" rel="noreferrer">{r.streamLink}</a> : ''}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
                {Array.isArray(importResult.duplicates) && importResult.duplicates.length > 0 && (
                  <div style={{ marginBottom:16 }}>
                    <div style={{ fontWeight:600, marginBottom:6 }}>Duplikate ({importResult.duplicates.length})</div>
                    <div style={{ overflowX:'auto', border:'1px solid rgba(255,255,255,0.15)', borderRadius:6 }}>
                      <table style={{ width:'100%', borderCollapse:'collapse' }}>
                        <thead>
                          <tr>
                            <th style={{ textAlign:'left', padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.15)' }}>ID</th>
                            <th style={{ textAlign:'left', padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.15)' }}>Slot</th>
                            <th style={{ textAlign:'left', padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.15)' }}>User</th>
                            <th style={{ textAlign:'left', padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.15)' }}>Start</th>
                            <th style={{ textAlign:'left', padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.15)' }}>Ende</th>
                            <th style={{ textAlign:'left', padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.15)' }}>Link</th>
                          </tr>
                        </thead>
                        <tbody>
                          {importResult.duplicates.map((r, idx) => (
                            <tr key={idx}>
                              <td style={{ padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.08)' }}>{r.id}</td>
                              <td style={{ padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.08)' }}>{r.slot}</td>
                              <td style={{ padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.08)' }}>{r.user}</td>
                              <td style={{ padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.08)' }}>{r.start ? new Date(r.start).toLocaleString() : ''}</td>
                              <td style={{ padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.08)' }}>{r.end ? new Date(r.end).toLocaleString() : ''}</td>
                              <td style={{ padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.08)' }}>
                                {r.streamLink ? <a href={r.streamLink} target="_blank" rel="noreferrer">{r.streamLink}</a> : ''}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
                {Array.isArray(importResult.skipped) && importResult.skipped.length > 0 && (
                  <div>
                    <div style={{ fontWeight:600, marginBottom:6 }}>Übersprungen ({importResult.skipped.length})</div>
                    <div style={{ overflowX:'auto', border:'1px solid rgba(255,255,255,0.15)', borderRadius:6 }}>
                      <table style={{ width:'100%', borderCollapse:'collapse' }}>
                        <thead>
                          <tr>
                            <th style={{ textAlign:'left', padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.15)' }}>Grund</th>
                            <th style={{ textAlign:'left', padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.15)' }}>Slot</th>
                            <th style={{ textAlign:'left', padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.15)' }}>User</th>
                            <th style={{ textAlign:'left', padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.15)' }}>Start</th>
                            <th style={{ textAlign:'left', padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.15)' }}>Ende</th>
                          </tr>
                        </thead>
                        <tbody>
                          {importResult.skipped.map((r, idx) => (
                            <tr key={idx}>
                              <td style={{ padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.08)' }}>{r.reason}</td>
                              <td style={{ padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.08)' }}>{r.slot}</td>
                              <td style={{ padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.08)' }}>{r.user || ''}</td>
                              <td style={{ padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.08)' }}>{r.start ? new Date(r.start).toLocaleString() : ''}</td>
                              <td style={{ padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.08)' }}>{r.end ? new Date(r.end).toLocaleString() : ''}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
            )}
            {preview && (
              <div style={{ marginTop:8, border:'1px solid rgba(255,255,255,0.15)', borderRadius:8, padding:12 }}>
                <div style={{ fontSize:13, opacity:.85, marginBottom:6 }}>
                  Quelle: <code style={{background:'#111827', padding:'2px 6px', borderRadius:4}}>{preview.sourceUrl}</code> · Typ: {preview.contentType || 'unbekannt'} · Bytes: {preview.bytesRead}
                </div>
                {Array.isArray(preview.rowsEF) && preview.rowsEF.length > 0 && (
                  <div style={{ marginBottom:12 }}>
                    <div style={{ fontWeight:600, marginBottom:6 }}>Spalten E & F (Zeilen 2–201)</div>
                    <div style={{ overflowX:'auto', border:'1px solid rgba(255,255,255,0.15)', borderRadius:6 }}>
                      <table style={{ width:'100%', borderCollapse:'collapse' }}>
                        <thead>
                          <tr>
                            <th style={{ textAlign:'left', padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.15)' }}>#</th>
                            <th style={{ textAlign:'left', padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.15)' }}>E</th>
                            <th style={{ textAlign:'left', padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.15)' }}>F</th>
                          </tr>
                        </thead>
                        <tbody>
                          {preview.rowsEF.map((r, idx) => (
                            <tr key={idx}>
                              <td style={{ padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.08)', opacity:.85 }}>{idx+2}</td>
                              <td style={{ padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.08)' }}>{r?.e || ''}</td>
                              <td style={{ padding:'6px 8px', borderBottom:'1px solid rgba(255,255,255,0.08)' }}>{r?.f || ''}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
                <div style={{ fontWeight:600, marginTop:4, marginBottom:4 }}>Rohdaten (Zeilen 2–201)</div>
                <pre style={{ maxHeight:420, overflow:'auto', background:'#0b1220', padding:12, borderRadius:6, whiteSpace:'pre', fontSize:12 }}>
{(preview.lines||[]).join('\n')}
                </pre>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
